import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function MindMapChemTopics() {
  return (
    <>

      <AllSubjectTopics subject="chemistry" type="mindmap" />


    </>
  );
}

export default MindMapChemTopics;